(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ys-static-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ys-static-reviews')) {
    customElements.define('ys-static-reviews', class extends HTMLElement {
      connectedCallback() {
        this.cards = Array.from(this.querySelectorAll('.ys-sr__card')).sort((a,b) => Number(a.dataset.reviewIndex)-Number(b.dataset.reviewIndex));
        this.grid = this.querySelector('.ys-sr__grid');
        if (!this.grid) return;
        this.abort = new AbortController();
        this.columnCount = 0;
        this.setAttribute('data-ready', '');
        this.addEventListener('click', event => {
          const button = event.target.closest('.ys-sr__toggle');
          if (!button || !this.contains(button)) return;
          const card = button.closest('.ys-sr__card');
          const expanded = card.toggleAttribute('data-expanded');
          button.setAttribute('aria-expanded', String(expanded));
          button.textContent = expanded ? this.dataset.readLess : this.dataset.readMore;
        }, { signal: this.abort.signal });
        this.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('.ys-sr__card');
          if (card) card.scrollIntoView({ block:'nearest' });
        }, { signal:this.abort.signal });
        this.observer = new ResizeObserver(() => this.layout());
        this.observer.observe(this.grid);
        this.layout();
      }
      layout() {
        const width = this.grid.clientWidth;
        if (!width) return;
        const count = width >= 1000 ? 4 : width >= 720 ? 3 : width >= 450 ? 2 : 1;
        if (count !== this.columnCount) {
          const focused = this.contains(document.activeElement) ? document.activeElement : null;
          const columns = Array.from({ length:count }, () => {
            const column = document.createElement('div');
            column.className = 'ys-sr__column';
            return column;
          });
          this.cards.forEach((card,index) => columns[index % count].append(card));
          this.grid.replaceChildren(...columns);
          this.columnCount = count;
          if (focused) focused.focus({ preventScroll:true });
        }
        this.cards.forEach(card => {
          const long = card.querySelector('.ys-sr__text').scrollHeight > 85;
          card.toggleAttribute('data-long', long);
          card.querySelector('.ys-sr__toggle').hidden = !long;
        });
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.abort?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
